<template>
  <div
    class="page-header align-items-start min-vh-100"
    style="background-color: transparent"
  >
    <span class="mask opacity-6"></span>
    <div class="container my-auto">
      <div class="row">
        <div class="col-lg-4 col-md-8 col-12 mx-auto">
          <div class="card z-index-0 fadeIn3 fadeInBottom">
            <div class="card-body">
              <img
                src="@/assets/img/logo.png"
                style="width: 40%; display: block; margin: 0 auto"
              />
              <p v-if="isAnnualOffer" class="text-sm text-center mt-3 mb-0">
                Plano anual Black Friday, R$ 997. Depois do cadastro o Pix abre nesta mesma jornada.
              </p>

              <form role="form" class="text-start mt-3">
                <DefaultInput
                  class="mb-2"
                  v-model="name"
                  label="Nome"
                  placeholder="Insira seu nome"
                />

                <DefaultInput
                  class="mb-2"
                  v-model="lastname"
                  label="Sobrenome"
                  placeholder="Insira seu sobrenome"
                />

                <DefaultInput
                  class="mb-2"
                  v-model="email"
                  label="E-mail"
                  type="email"
                  placeholder="Insira seu e-mail"
                />

                <DefaultInput
                  class="mb-2"
                  v-model="password"
                  label="Senha"
                  type="password"
                  placeholder="Insira sua senha"
                />

                <div
                  class="input-group input-group-outline m-0 d-flex flex-column"
                >
                  <label class="input-label">
                    <span
                      class="text-xs text-uppercase text-body font-weight-bolder"
                      >WhatsApp</span
                    >
                    <PhoneInput v-model="phone" />
                  </label>
                </div>

                <div
                  class="input-group input-group-outline m-0 d-flex flex-column"
                >
                  <label class="input-label">
                    <span
                      class="text-xs text-uppercase text-body font-weight-bolder"
                      >CPF/CNPJ</span
                    >
                    <input
                      v-model="document"
                      type="text"
                      class="form-control default-bordered-input"
                      v-mask="['###.###.###-##', '##.###.###/####-##']"
                      placeholder="Insira seu CPF ou CNPJ"
                    />
                  </label>
                </div>

                <DefaultSelect
                  class="mb-2 mt-2"
                  v-model="signupSource"
                  label="Como conheceu a Rifa365?"
                  placeholder="Selecione uma opção"
                  :options="signupSourceOptions"
                />

                <!-- Honeypot anti-bot (oculto; humanos não preenchem) -->
                <div
                  aria-hidden="true"
                  style="position: absolute; left: -9999px; top: -9999px; height: 0; overflow: hidden"
                >
                  <label>
                    Website
                    <input
                      v-model="website"
                      type="text"
                      name="website"
                      tabindex="-1"
                      autocomplete="off"
                    />
                  </label>
                </div>

                <div
                  v-if="turnstileSiteKey"
                  class="mt-3 d-flex justify-content-center"
                  ref="turnstileContainer"
                ></div>

                <div class="text-center mt-3 mb-2">
                  <p class="text-xs text-secondary">
                    Ao se registrar, você está aceitando nossos
                    <a
                      href="#"
                      class="text-info font-weight-bold"
                      @click.prevent="termsDialog = true"
                      >Termos de Uso</a
                    >
                    e
                    <a
                      href="#"
                      class="text-info font-weight-bold"
                      @click.prevent="policyDialog = true"
                      >Política de Privacidade</a
                    >.
                  </p>
                </div>
                <div class="text-center">
                  <button
                    class="btn btn-icon btn-3 campaign-btn m-0"
                    type="button"
                    disabled
                    v-if="loading"
                  >
                    <span class="btn-inner--text btn-text">Aguarde...</span>
                  </button>
                  <button
                    class="btn btn-icon btn-3 campaign-btn m-0"
                    type="button"
                    @click.prevent="register"
                    v-if="!loading"
                  >
                    <span class="btn-inner--text btn-text">Cadastrar</span>
                  </button>
                </div>
                <p class="mt-4 text-sm text-center">
                  Já tem conta?
                  <router-link
                    :to="{ name: 'SignIn', query: $route.query.affiliate_campaign ? { affiliate_campaign: $route.query.affiliate_campaign } : {} }"
                    class="text-success text-gradient font-weight-bold"
                    >Fazer login</router-link
                  >
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Terms :isOpen="termsDialog" @close="termsDialog = false" />
    <Policy :isOpen="policyDialog" @close="policyDialog = false" />
  </div>
</template>

<script>
import DefaultInput from "@/components/DefaultInput.vue";
import DefaultSelect from "@/components/DefaultSelect.vue";
import PhoneInput from "@/components/PhoneInput.vue";
import Terms from "@/views/Raffles/RafflesCreation/components/Terms.vue";
import Policy from "@/views/Raffles/RafflesCreation/components/Policy.vue";
import { mask } from "vue-the-mask";
import { mapMutations } from "vuex";

import validateCPF from "@/utils/validateCPF";
import validateCNPJ from "@/utils/validateCNPJ";
import LoggingMixin from "@/mixins/LoggingMixin.js";
import { toWhatsAppNumber } from "@/helpers/phoneNumber.js";
import {
  capturePlatformAffiliateRef,
  resolvePlatformAffiliateRef,
  getPlatformAffiliateRef,
} from "@/utils/platformAffiliateRef.js";

import AuthHttp from "@/http/AuthHttp.js";
import WhatsappHttp from "@/http/WhatsappHttp.js";

export default {
  name: "sign-up",
  mixins: [LoggingMixin],
  components: {
    DefaultInput,
    DefaultSelect,
    PhoneInput,
    Terms,
    Policy,
  },
  directives: {
    mask,
  },
  computed: {
    isAnnualOffer() {
      return String(this.$route.query.plan || "").toLowerCase() === "anual";
    },
  },
  data() {
    return {
      loading: false,
      termsDialog: false,
      policyDialog: false,
      name: "",
      lastname: "",
      email: "",
      password: "",
      phone: "",
      document: "",
      signupSource: "",
      website: "", // honeypot
      captchaToken: "",
      utmSource: "",
      utmMedium: "",
      utmCampaign: "",
      utmContent: "",
      utmTerm: "",
      turnstileSiteKey: process.env.VUE_APP_TURNSTILE_SITE_KEY || "0x4AAAAAAEEemGw_xYPnHLxQ",
      turnstileWidgetId: null,
      signupSourceOptions: [
        { label: "Google", value: "google" },
        { label: "Instagram", value: "instagram" },
        { label: "Facebook", value: "facebook" },
        { label: "YouTube", value: "youtube" },
        { label: "TikTok", value: "tiktok" },
        { label: "Indicação de amigo", value: "indicacao" },
        { label: "Grupo de WhatsApp/Telegram", value: "grupo" },
        { label: "Anúncio", value: "anuncio" },
        { label: "Outro", value: "outro" },
      ],
      disposableDomains: [
        "mailinator.com",
        "guerrillamail.com",
        "tempmail.com",
        "temp-mail.org",
        "yopmail.com",
        "10minutemail.com",
        "throwaway.email",
        "trashmail.com",
        "maildrop.cc",
        "getnada.com",
        "sharklasers.com",
        "grr.la",
      ],
    };
  },
  beforeMount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
  },
  mounted() {
    const affiliateCampaign = this.$route.query.affiliate_campaign;
    if (affiliateCampaign) {
      sessionStorage.setItem("pending_affiliate_campaign", affiliateCampaign);
    }
    if (this.$route.query.ref) {
      capturePlatformAffiliateRef(this.$route.query.ref);
    }
    // UTM da URL (Instagram, YouTube, ads…) — grava no evento organizer_signup
    const q = this.$route.query || {};
    this.utmSource = String(q.utm_source || "").trim();
    this.utmMedium = String(q.utm_medium || "").trim();
    this.utmCampaign = String(q.utm_campaign || "").trim();
    this.utmContent = String(q.utm_content || "").trim();
    this.utmTerm = String(q.utm_term || "").trim();
    // Se veio pelo link de afiliado, sugere "Indicação de amigo"
    if (
      !this.signupSource &&
      (this.$route.query.ref || getPlatformAffiliateRef())
    ) {
      this.signupSource = "indicacao";
    }
    this.mountTurnstile();
  },
  beforeUnmount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
    this.destroyTurnstile();
  },
  methods: {
    ...mapMutations(["toggleEveryDisplay", "toggleHideConfig"]),
    async handleInputValue(event) {
      const { name, value } = event.target;
      this[name] = value;
    },

    loadTurnstileScript() {
      return new Promise((resolve, reject) => {
        if (window.turnstile) {
          resolve();
          return;
        }
        const existing = document.querySelector(
          'script[src*="challenges.cloudflare.com/turnstile"]'
        );
        if (existing) {
          existing.addEventListener("load", () => resolve());
          existing.addEventListener("error", reject);
          return;
        }
        const script = document.createElement("script");
        script.src =
          "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
        script.async = true;
        script.onload = () => resolve();
        script.onerror = reject;
        document.head.appendChild(script);
      });
    },

    async mountTurnstile() {
      if (!this.turnstileSiteKey || !this.$refs.turnstileContainer) return;
      try {
        await this.loadTurnstileScript();
        this.turnstileWidgetId = window.turnstile.render(
          this.$refs.turnstileContainer,
          {
            sitekey: this.turnstileSiteKey,
            callback: (token) => {
              this.captchaToken = token;
            },
            "expired-callback": () => {
              this.captchaToken = "";
            },
            "error-callback": () => {
              this.captchaToken = "";
            },
          }
        );
      } catch (e) {
        console.warn("[signup] Turnstile indisponível", e);
      }
    },

    destroyTurnstile() {
      try {
        if (
          this.turnstileWidgetId != null &&
          window.turnstile &&
          typeof window.turnstile.remove === "function"
        ) {
          window.turnstile.remove(this.turnstileWidgetId);
        }
      } catch (e) {
        /* ignore */
      }
      this.turnstileWidgetId = null;
      this.captchaToken = "";
    },

    isDisposableEmail(email) {
      const at = String(email || "")
        .toLowerCase()
        .trim()
        .lastIndexOf("@");
      if (at < 0) return false;
      const domain = email.slice(at + 1).toLowerCase();
      return this.disposableDomains.some(
        (d) => domain === d || domain.endsWith("." + d)
      );
    },

    formatPhoneForApi(phone) {
      return toWhatsAppNumber(phone);
    },
    async validateInputs() {
      if (
        !this.name ||
        !this.lastname ||
        !this.email ||
        !this.password ||
        !this.phone ||
        !this.document
      ) {
        this.$toast.add({
          severity: "error",
          summary: "Erro ao cadastrar",
          detail: "Preencha todos os campos corretamente.",
          life: 3000,
        });
        return false;
      }

      if (this.isDisposableEmail(this.email)) {
        this.$toast.add({
          severity: "error",
          summary: "E-mail não permitido",
          detail:
            "Use um e-mail permanente. Endereços temporários não são permitidos.",
          life: 5000,
        });
        return false;
      }

      if (!this.signupSource) {
        this.$toast.add({
          severity: "error",
          summary: "Erro ao cadastrar",
          detail: "Selecione como conheceu a Rifa365.",
          life: 3000,
        });
        return false;
      }

      if (this.turnstileSiteKey && !this.captchaToken) {
        this.$toast.add({
          severity: "error",
          summary: "Captcha",
          detail: "Confirme o captcha antes de continuar.",
          life: 3000,
        });
        return false;
      }

      const rawDocument = this.document.replace(/\D/g, '');

      if (rawDocument.length === 11) {
        if (!validateCPF(this.document)) {
          this.$toast.add({
            severity: "error",
            summary: "Erro ao cadastrar",
            detail: "CPF inválido.",
            life: 3000,
          });
          return false;
        }
      } else if (rawDocument.length === 14) {
        if (!validateCNPJ(this.document)) {
          this.$toast.add({
            severity: "error",
            summary: "Erro ao cadastrar",
            detail: "CNPJ inválido.",
            life: 3000,
          });
          return false;
        }
      } else {
        this.$toast.add({
          severity: "error",
          summary: "Erro ao cadastrar",
          detail: "Documento (CPF/CNPJ) incompleto ou inválido.",
          life: 3000,
        });
        return false;
      }

      return true;
    },
    async register() {
      try {
        if (!(await this.validateInputs())) {
          return;
        }

        const formattedPhone = this.formatPhoneForApi(this.phone);

        const response = await WhatsappHttp.checkNumber(formattedPhone);

        if (response && response.data.at(0).exists === false) {
          this.$toast.add({
            severity: "error",
            summary: "Erro ao consultar número",
            detail:
              "Certifique-se que o telefone inserido é um whatsapp válido.",
            life: 3000,
          });
          return;
        }
      } catch (error) {
        console.error(error);
      }
      this.$toast.add({
        severity: "info",
        summary: "Aguarde...",
        detail: "Estamos criando sua conta.",
        life: 3000,
      });
      try {
        this.loading = true;
        const payload = {
          full_name: `${this.name} ${this.lastname}`,
          email: this.email,
          password: this.password,
          phone: this.phone,
          document: this.document,
          signup_source: this.signupSource,
          website: this.website,
          captcha_token: this.captchaToken || undefined,
        };
        if (this.utmSource) payload.utm_source = this.utmSource;
        if (this.utmMedium) payload.utm_medium = this.utmMedium;
        if (this.utmCampaign) payload.utm_campaign = this.utmCampaign;
        if (this.utmContent) payload.utm_content = this.utmContent;
        if (this.utmTerm) payload.utm_term = this.utmTerm;
        
        const referredBy = resolvePlatformAffiliateRef(this.$route.query.ref);
        if (referredBy) {
          payload.referred_by = referredBy;
        }

        const response = await AuthHttp.signUp(payload);
        if (response.data.id) {
          this.$log.log(
            "AUTH",
            "CADASTRO",
            `Nova conta criada - Email: ${this.email}, Telefone: ${this.phone}`
          );
          try {
            if (typeof window.fbq === "function") {
              window.fbq("track", "CompleteRegistration");
            }
            if (typeof window.gtag === "function") {
              window.gtag("event", "sign_up", { method: "email" });
            }
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ event: "rifa365_complete_registration" });
          } catch (e) {
            console.warn("[signup] conversion track fail-open", e);
          }
          if (this.isAnnualOffer && response.data.token) {
            sessionStorage.setItem("bf_checkout_email", this.email.trim());
            sessionStorage.setItem("bf_checkout_token", response.data.token);
            this.loading = false;
            this.$router.push({ name: "BlackFridayPix" });
            return;
          }
          this.$toast.add({
            severity: "success",
            summary: "Eba!",
            detail:
              "Sua conta foi criada com sucesso! Enviamos o link de confirmação para o WhatsApp e para o e-mail informados. Use qualquer um dos dois para validar e liberar o login.",
            life: 12000,
          });
          this.loading = false;
          // Preservar parâmetro de afiliação ao redirecionar para o login
          const affiliateCampaign = this.$route.query.affiliate_campaign;
          if (affiliateCampaign) {
            this.$router.push({ path: "/sign-in", query: { affiliate_campaign: affiliateCampaign } });
          } else {
            this.$router.push("/sign-in");
          }
        }
      } catch (error) {
        if (error.error && error.error.indexOf("Email already exists") > -1) {
          this.$log.logError(
            `Tentativa de cadastro com e-mail existente: ${this.email}`,
            "SignUp"
          );
          this.$toast.add({
            severity: "warn",
            summary: "Atenção",
            detail:
              "Este e-mail parece já estar vinculado a uma conta no Rifa365. Caso necessário, entre em contato com nosso suporte.",
            life: 3000,
          });
          this.loading = false;
          return;
        }
        if (error.error && error.error.indexOf("Document already exists") > -1) {
          this.$log.logError(
            `Tentativa de cadastro com documento existente: ${this.document}`,
            "SignUp"
          );
          this.$toast.add({
            severity: "warn",
            summary: "Atenção",
            detail:
              "Este CPF/CNPJ já está vinculado a uma conta no Rifa365. Caso necessário, entre em contato com nosso suporte.",
            life: 3000,
          });
          this.loading = false;
          return;
        }
        if (
          error.error &&
          (String(error.error).indexOf("temporários") > -1 ||
            String(error.error).indexOf("e-mail permanente") > -1)
        ) {
          this.$toast.add({
            severity: "error",
            summary: "E-mail não permitido",
            detail: error.error,
            life: 5000,
          });
          this.loading = false;
          return;
        }
        const errMsg = error.error || error.message || "Erro desconhecido";
        this.$log.logError(`Erro ao criar conta: ${errMsg}`, "SignUp");
        this.$toast.add({
          severity: "error",
          summary: "Erro ao cadastrar",
          detail: errMsg,
          life: 5000,
        });
        console.error(error);
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped lang="scss">
.campaign-btn {
  color: #ffffff;
  background-color: #e41b80;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  line-height: 0;
  height: 40px;
  width: 100%;
  margin-top: 15px !important;

  .btn-icon {
    font-size: 1.6em;
  }

  &:hover {
    color: #ffffff;
  }
}

.more-btn {
  background-color: transparent;
  border: none;
  padding: 0;
  margin: 0;
}

.no-campaign {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-bottom: 15px;
  padding: 50px 0;
}
</style>
